import {
    createInvoiceField,
    createInvoiceFieldValidation,
} from 'constants/FormField/createInvoiceField'
import useFromFieldWithAccount from 'logic/useFromFieldWithAccount'

const useInvoices = () => {
    const {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    } = useFromFieldWithAccount({
        fieldsCreate: createInvoiceField,
        fieldsEdit: createInvoiceField,
        validationSchema: createInvoiceFieldValidation,
    })

    return {
        fieldsCreate,
        fieldsEdit,
        isLoading: isLoadingAccount,
        validationSchema,
    }
}

export default useInvoices
